import React from "react";
import { useHistory } from "react-router";

export default function ImportPreviewMessage(props){
	let {
			clearMessage,
			jobId,
			...info
		} = props
		, libraryName = info?.data?.creativeLibrary?.name || info?.data?.library?.name
		, clear = null
		, message = info.data?.response?.feedback || ""
		, filename = info.data?.request?.filename || "versions"
		, libraryId = info.data?.creativeLibrary?.id
		, url = `/library/${libraryId}/modal/preview-version-import/${jobId}/`
		;

	const history = useHistory();

	function openPreview(e){
		e.preventDefault();
		history.push(url);
	}

	if(/in progress/gi.test(info.status)){
		message = (<p>Import in progress...</p>);
	}

	if (/success/gi.test(info.status)) {
		const updatedCreatives = (info.data?.response?.changes?.creatives || []).filter((creative) => {
			const creativeChanges = creative.updated + creative.new;
			return creativeChanges > 0;
		});

		if(updatedCreatives.length){
			message = (
				<>
					<p>
						<span className="name-overflow">{`Import of "${filename}"`}</span>
						is ready to preview
					</p>
					<p><a href="#" onClick={openPreview}>Preview Import</a></p>
				</>
			);

			info.iconInfo = {
				title: 'Success',
				icon: 'fas fa-check-circle is-success',
			};
		} else {
			message = <p>No new versions</p>;
			info.iconInfo = {
				title: 'Warn',
				icon: 'fas fa-info-circle',
			};
		}
	}

	if(/failed/gi.test(info.status)) {
		message = (<p>Import versions failed, please try again</p>);
		info.iconInfo = {
			title: 'Failed',
			icon: 'fas fa-times-circle is-error',
		};
	}

	if(/in progress/gi.test(info.status)){
		// If we don't include an element in this spot, the library name gets truncated in a stupid way.
		clear = <b key="clear" />;
	} else{
		clear = <i key="clear" className="ft-ic fal fa-times clear-message" title="Clear Message" onClick={clearMessage} />;
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${info.iconInfo?.icon}`} title={info.iconInfo?.title} />
		, <div key="body" className="message-body">{message}</div>
		, clear
		, <b key="empty" />
		, <span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName || "Library"}</span>
		, <time key="time" className="message-time" dateTime={info?.timestamp}>{info?.prettyTime}</time>
	];
}
ImportPreviewMessage.displayName = "ImportPreviewMessage";
